import classNames                       from 'classnames';
import React, { FC }                    from 'react';
import { Cell, Grid }                   from 'styled-css-grid';
import { GridProps, Label, LabelProps } from 'semantic-ui-react';

import { StyledContainer, StyledContainerProps } from '../../../../../containers';
import { CorvalUIColor, SemanticUIColor, Size }  from '../../../../../../types';
import { StringOrEmpty }                         from '../../../../../components/display/StringOrEmpty';

export interface VisualizationSummaryTileProps {
	bgColor?: SemanticUIColor.TEAL | CorvalUIColor.DARKTEAL | SemanticUIColor.GREY | SemanticUIColor.PURPLE,
	metricValue?: string | number,
	labelValue?: string,
	
	className?: StyledContainerProps['className'],
	style?: StyledContainerProps['style'],
	zIndex?: StyledContainerProps['zIndex'],
	
	gridProps?: GridProps,
	labelProps?: LabelProps,
}

const defaultProps: VisualizationSummaryTileProps = {
	bgColor:     SemanticUIColor.TEAL,
	metricValue: null,
	labelValue:  null,
	
	className: null,
	style:     null,
	zIndex:    null,
	
	gridProps:  {},
	labelProps: {},
}

const VisualizationSummaryTile: FC<VisualizationSummaryTileProps> = ( props ) => {
	
	let { bgColor, metricValue, labelValue, gridProps, labelProps, ...containerProps } = props;
	
	return (
		
		<StyledContainer bgColor={ bgColor }
		                 padding={ [ null, Size.SM, null, null ] }
		                 zIndex={ containerProps.zIndex }
		                 className={
			                 classNames(
				                 containerProps.className,
				                 'text--no-wrap'
			                 )
		                 }
		                 style={ {
			                 borderRadius: 10,
			                 height:       20,
			                 overflowY:    'hidden',
			                 overflowX:    'hidden',
			                 textOverflow: 'ellipses',
			                 ...( containerProps.style ?? {} )
		                 } }>
			
			<Grid columns={ `auto 1fr` } { ...( gridProps ?? {} ) }>
				<Cell middle>
					{ metricValue &&
					<Label horizontal basic circular size={ 'mini' } color={ bgColor as SemanticUIColor } { ...labelProps }>{ metricValue }</Label> }
				</Cell>
				<Cell middle className={ 'text--colored-white text--xs text--strong' }>
					<StringOrEmpty evaluate={ labelValue } passValue={ labelValue.toUpperCase() } emptyValue={ null }/>
				</Cell>
			</Grid>
		</StyledContainer>
	);
};

VisualizationSummaryTile.defaultProps = defaultProps;

export { VisualizationSummaryTile }
